import { ToastBar, toast } from "react-hot-toast";
export const TOAST_CONFIGS = {
  position: "top-center",
};

export function CustomToaster(t) {
  return (
    <ToastBar toast={t}>
    </ToastBar>
  );
}

const overrides = {
  success: toast.success,
  error: toast.error,
};

export default overrides;
